import { render, staticRenderFns } from "./RegistroFotoCuip.vue?vue&type=template&id=faedfe14&scoped=true"
import script from "./RegistroFotoCuip.vue?vue&type=script&lang=js"
export * from "./RegistroFotoCuip.vue?vue&type=script&lang=js"
import style0 from "./RegistroFotoCuip.vue?vue&type=style&index=0&id=faedfe14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faedfe14",
  null
  
)

export default component.exports